/**
 * Automatic Discount Display - Simple Event Listener
 *
 * Listens for variant price changes and applies discount based on product tags
 * (e.g., _discount_25 for 25% off)
 *
 * @version 2.0 - Simplified
 */

(function() {
  'use strict';

  // Function to update price with discount
  function updateDiscountPrice(container, variant) {
    var priceElement = container.querySelector('[data-product-price]');
    if (!priceElement) return;

    var autoDiscountPercent = priceElement.dataset.autoDiscountPercent;
    if (!autoDiscountPercent || parseFloat(autoDiscountPercent) <= 0) return;

    var autoDiscountWrap = container.querySelector('[data-auto-discount-wrap]');
    var autoDiscountOriginal = container.querySelector('[data-auto-discount-original]');
    var autoDiscountSavings = container.querySelector('[data-auto-discount-savings]');

    console.log('💰 Applying discount:', autoDiscountPercent + '%', 'to price:', variant.price);

    // Check if there's a regular sale first (compare_at_price)
    if (variant.compare_at_price > variant.price) {
      console.log('⚠️ Product already on sale, skipping automatic discount');
      // Hide automatic discount elements
      if (autoDiscountWrap) autoDiscountWrap.classList.add('hide');
      if (autoDiscountSavings) autoDiscountSavings.classList.add('hide');
      return;
    }

    // Calculate discounted price
    var discountMultiplier = (100 - parseFloat(autoDiscountPercent)) / 100;
    var discountedPrice = variant.price * discountMultiplier;

    console.log('✅ Discounted price:', discountedPrice);

    // Update price display
    priceElement.innerHTML = theme.Currency.formatMoney(discountedPrice, theme.settings.moneyFormat);
    priceElement.classList.add('on-sale');

    // Show/update original price
    if (autoDiscountOriginal) {
      autoDiscountOriginal.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
    }
    if (autoDiscountWrap) {
      autoDiscountWrap.classList.remove('hide');
    }

    // Calculate and show savings
    var savings = variant.price - discountedPrice;
    if (theme.settings.saveType === 'percent') {
      savings = autoDiscountPercent + '%';
    } else {
      savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
    }

    if (autoDiscountSavings && theme.strings.savePrice) {
      autoDiscountSavings.classList.remove('hide');
      autoDiscountSavings.innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);
    }

  }

  // Store original Recharge prices for restoration
  var originalRechargeConfig = null;

  // Function to apply discount to Recharge v2 widget configuration
  function applyDiscountToRechargeConfig(autoDiscountPercent) {
    if (!window.SubscriptionWidgetConfig || !window.SubscriptionWidgetConfig.formattedPrices) {
      console.log('💳 Recharge config not found yet');
      return false;
    }

    if (!autoDiscountPercent || parseFloat(autoDiscountPercent) <= 0) {
      console.log('💳 No discount to apply to Recharge');
      return false;
    }

    var discountPercent = parseFloat(autoDiscountPercent);
    var discountMultiplier = (100 - discountPercent) / 100;

    console.log('💳 Applying ' + discountPercent + '% discount to Recharge widget config');

    // Store original config if not already stored
    if (!originalRechargeConfig) {
      originalRechargeConfig = JSON.parse(JSON.stringify(window.SubscriptionWidgetConfig.formattedPrices));
      console.log('💳 Stored original Recharge config');
    }

    // Apply discount to all variant unit prices
    var formattedPrices = window.SubscriptionWidgetConfig.formattedPrices;
    for (var variantId in formattedPrices) {
      if (formattedPrices.hasOwnProperty(variantId)) {
        var variantConfig = formattedPrices[variantId];

        // Get original price (either from stored config or current)
        var originalPrice = originalRechargeConfig[variantId].unit;

        // Parse price string to cents (e.g., "$97.00" -> 9700)
        var priceMatch = originalPrice.match(/[\d.]+/);
        if (priceMatch) {
          var priceInDollars = parseFloat(priceMatch[0]);
          var priceInCents = Math.round(priceInDollars * 100);

          // Apply discount
          var discountedPriceInCents = Math.round(priceInCents * discountMultiplier);

          // Format back to money string
          var discountedPrice = theme.Currency.formatMoney(discountedPriceInCents, theme.settings.moneyFormat);

          // Update the config - both unit (one-time) and discounted (for comparison)
          variantConfig.unit = discountedPrice;

          // Also update the 'discounted' field if it exists to keep pricing consistent
          if (variantConfig.discounted) {
            variantConfig.discounted = discountedPrice;
          }

          console.log('💳 Variant ' + variantId + ': ' + originalPrice + ' → ' + discountedPrice);
        }
      }
    }

    console.log('✅ Recharge config updated with discount');
    return true;
  }

  // Function to restore original Recharge prices (when variant changes to non-discounted)
  function restoreRechargeConfig() {
    if (!originalRechargeConfig || !window.SubscriptionWidgetConfig) {
      return;
    }

    console.log('💳 Restoring original Recharge prices');
    window.SubscriptionWidgetConfig.formattedPrices = JSON.parse(JSON.stringify(originalRechargeConfig));
  }

  // Function to update Recharge config for specific variant on variant change
  function updateRechargeConfigForVariant(variant, autoDiscountPercent) {
    if (!window.SubscriptionWidgetConfig || !window.SubscriptionWidgetConfig.formattedPrices) {
      return;
    }

    var variantId = variant.id.toString();
    var formattedPrices = window.SubscriptionWidgetConfig.formattedPrices;

    if (!formattedPrices[variantId]) {
      console.log('💳 Variant ' + variantId + ' not found in Recharge config');
      return;
    }

    // Store original if not already stored
    if (!originalRechargeConfig) {
      originalRechargeConfig = JSON.parse(JSON.stringify(formattedPrices));
    }

    var variantConfig = formattedPrices[variantId];
    var originalPrice = originalRechargeConfig[variantId].unit;

    // If discount is active and product not on sale
    if (autoDiscountPercent && parseFloat(autoDiscountPercent) > 0 && variant.compare_at_price <= variant.price) {
      var discountPercent = parseFloat(autoDiscountPercent);
      var discountMultiplier = (100 - discountPercent) / 100;

      var priceMatch = originalPrice.match(/[\d.]+/);
      if (priceMatch) {
        var priceInDollars = parseFloat(priceMatch[0]);
        var priceInCents = Math.round(priceInDollars * 100);
        var discountedPriceInCents = Math.round(priceInCents * discountMultiplier);
        var discountedPrice = theme.Currency.formatMoney(discountedPriceInCents, theme.settings.moneyFormat);

        variantConfig.unit = discountedPrice;

        // Also update the 'discounted' field if it exists
        if (variantConfig.discounted) {
          variantConfig.discounted = discountedPrice;
        }

        console.log('💳 Updated variant ' + variantId + ' Recharge price: ' + originalPrice + ' → ' + discountedPrice);
      }
    } else {
      // Restore original prices
      variantConfig.unit = originalPrice;

      if (originalRechargeConfig[variantId].discounted) {
        variantConfig.discounted = originalRechargeConfig[variantId].discounted;
      }

      console.log('💳 Restored variant ' + variantId + ' Recharge price: ' + originalPrice);
    }
  }

  // Initialize on page load
  function init() {
    console.log('🚀 Automatic Discount: Initializing...');

    // Find all product containers
    var productContainers = document.querySelectorAll('[data-section-type="product"]');
    console.log('🔍 Found', productContainers.length, 'product containers');

    productContainers.forEach(function(container) {
      // Get discount percent from price element
      var priceElement = container.querySelector('[data-product-price]');
      var autoDiscountPercent = priceElement ? priceElement.dataset.autoDiscountPercent : null;

      // Apply discount to Recharge v2 widget config on page load
      if (autoDiscountPercent && parseFloat(autoDiscountPercent) > 0) {
        console.log('💳 Found discount percent:', autoDiscountPercent);

        // Try to apply discount immediately if config exists
        var applied = applyDiscountToRechargeConfig(autoDiscountPercent);

        // If config not ready yet, wait a bit and try again
        if (!applied) {
          setTimeout(function() {
            applyDiscountToRechargeConfig(autoDiscountPercent);
          }, 500);
        }
      }

      // Listen for variant price changes
      container.addEventListener('variantPriceChange', function(event) {
        console.log('🔄 Variant price changed!', event.detail.variant);
        updateDiscountPrice(container, event.detail.variant);
      });

      // Listen for variantChange to update Recharge widget config
      container.addEventListener('variantChange', function(event) {
        var variant = event.detail.variant;
        if (!variant) return;

        var priceElement = container.querySelector('[data-product-price]');
        if (priceElement) {
          var autoDiscountPercent = priceElement.dataset.autoDiscountPercent;
          updateRechargeConfigForVariant(variant, autoDiscountPercent);
        }
      });
    });

    console.log('✅ Automatic Discount: Ready!');
  }

  // Wait for page to load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
